import React from 'react'
import { usePutRequest } from '../../hooks/request'
import { ANIMAL_DETAIL } from '../../urls'
import { useMessage } from '../../hooks/message'
import AnimalForm from './AnimalForm'

export default function AnimalUpdate({ onCancel, onSuccess, item, animalTypes }) {
    const animalUpdate = usePutRequest({ url: ANIMAL_DETAIL.replace('{id}', item.id) })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const formData = new FormData()

        // Add all fields to FormData (use camelCase, humps will convert to snake_case)
        formData.append('identificationNumber', data.identificationNumber)
        formData.append('gender', data.gender)
        formData.append('ageCategory', data.ageCategory || 'adult')
        formData.append('acquisitionType', data.acquisitionType || 'purchased')
        formData.append('animalType', data.animalType)
        formData.append('status', data.status || 'active')

        if (data.birthDate) {
            formData.append('birthDate', data.birthDate)
        }

        if (data.notes) {
            formData.append('notes', data.notes)
        }

        if (data.weight) {
            formData.append('weight', data.weight)
        }

        // Add disposal information if status is not 'active'
        if (data.status !== 'active') {
            if (data.disposalDate) {
                formData.append('disposalDate', data.disposalDate)
            }
            if (data.disposalReason) {
                formData.append('disposalReason', data.disposalReason)
            }
        }

        // Add sold price if status is 'sold'
        if (data.status === 'sold' && data.soldPrice) {
            formData.append('soldPrice', data.soldPrice)
        }

        // Only append image if a new file is selected
        if (data.image && data.image instanceof File) {
            formData.append('image', data.image)
        }

        const { success } = await animalUpdate.request({
            data: formData
        })

        if (success) {
            showMessage('Ҳайвон маълумотлари муваффақиятли ўзгартирилди', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Ҳайвон маълумотларини ўзгартириш</b>
            </h1>
            <AnimalForm
                loading={animalUpdate.loading}
                initialValues={item}
                onSubmit={onSubmit}
                onCancel={onCancel}
                animalTypes={animalTypes}
            />
        </div>
    )
}
